/**
 * Hook liviano para cargar las cajas de contabilidad desde el módulo de otros-tramites.
 * Reutiliza la misma query key que useCajas de contabilidad, así comparten el caché.
 */
import { useQuery } from '@tanstack/react-query';
import { contabilidadService } from '@/contabilidad/services/contabilidadService';
import type { CuentaBancaria } from '@/contabilidad/types';

const CAJAS_QUERY_KEY = ['contabilidad', 'cajas'] as const;

export function useCajasContabilidad() {
  const { data, isLoading } = useQuery<CuentaBancaria[]>({
    queryKey: CAJAS_QUERY_KEY,
    queryFn: () => contabilidadService.getCajas(),
    staleTime: 1000 * 60 * 5,
  });

  return {
    cajas: data ?? [],
    isLoadingCajas: isLoading,
  };
}
